export default __webpack_public_path__ + "static/media/events-logo.95bae4bf.svg";